import React from 'react'

import Field from '@utilities/Field'

export class CheckboxField extends Field {
  displayName = 'CheckboxField'

  handleFocus() {
    const { name, onFocus } = this.props
    if (onFocus) {
      onFocus(name)
    }
  }

  handleChange() {
    const { name, field } = this.props
    this.props.onChange(name, !field.value)
  }

  handleBlur() {
    const { name } = this.props
    this.props.onBlur(name)
  }

  render() {
    const { field, name, label, optional } = this.props
    let error = field.touched && field.error
    let fieldClassName = 'Field'
    let inputContainerClassName = 'Checkbox'
    let fieldError

    // Required
    if (!optional) {
      fieldClassName += ' -is-required'
    }

    if (error) {
      fieldClassName += ' -has-errors'
      fieldError = (
        <ul className="FieldErrors">
          <li>{error}</li>
        </ul>
      )
    }

    return (
      <div className={fieldClassName}>
        <div className="Control">
          <div className={inputContainerClassName}>
            <label htmlFor={name}>{label}</label>
            <input
              type="checkbox"
              id={name}
              name={name}
              checked={field.value === true}
              onFocus={this.handleFocus}
              onBlur={this.handleBlur}
              onChange={this.handleChange}
            />
          </div>

          {fieldError}
        </div>
      </div>
    )
  }
}

export default CheckboxField
